import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthFacade } from './auth/auth.facade';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { CoreComponent } from "./core/containers/core/core.component";
import { LoaderComponent } from "@shared/components/loader/loader.component";
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styles: ``,
    imports: [CoreComponent, LoaderComponent, SkeletonModule]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Aimtec DI';

  isAuth = false;

  constructor(private authFacade: AuthFacade, private titleService: Title) {
    this.title = $localize`Aimtec DI`;
    this.titleService.setTitle(this.title);
  }

  ngOnInit(): void {
    this.authFacade.initAll();
    this.authFacade.isAuth$.subscribe(isAuth => this.isAuth = isAuth);
  }  
  
  ngOnDestroy(): void {
    this.authFacade.destroy();
  }
}
